onDomLoad(($dom) => {
  $dom
    .find("[data-behaviour='show-account-mapping-list-upload-input']")
    .each(function (index, el) {
      el.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        document
          .querySelector('#account-mapping-list-upload-input')
          .classList.remove('sf-hidden')
        e.target.classList.add('sf-hidden')
      })
    })
})
